import { supabase } from '../config/supabase';

export const submissionsService = {
  async submit(type, content) {
    const { data: { user } } = await supabase.auth.getUser();
    
    const { data, error } = await supabase
      .from('hahub_submissions')
      .insert({
        submitter_id: user?.id,
        type,
        content,
        status: 'submitted'
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async getMySubmissions() {
    const { data, error } = await supabase
      .from('hahub_submissions')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  },

  async getAdminStats() {
    // BUG F FIXED: Using prefixed function name
    const { data, error } = await supabase.rpc('hahub_get_admin_stats');
    if (error) throw error;
    return data;
  }
};